<div class="custom-hub-container">
  <app-breadcrumbs
    [isOnlyHomeActive]="true"
    [isDesktop]="isDesktop">
  </app-breadcrumbs>

  <app-page-content-wrapper
    class="custom-hub-container__component"
    [contentPadding]="isMobileOrTablet ? '20px' : '32px'">

    <app-custom-page-info
      [title]="(customPageConfig$ | async).title"
      [introText]="
        ((customSeoContent$ | async)?.active &&
          (customSeoContent$ | async)?.introContent) ||
        (customPageConfig$ | async).introText
      "
      [isMobileOrTablet]="isMobileOrTablet">
    </app-custom-page-info>

    <app-custom-hub-grid
      [categories]="customPageCategories$ | async"
      [isMobileOrTablet]="isMobileOrTablet">
    </app-custom-hub-grid>

    <app-best-selling-products-list
      [isMobile]="isMobile"
      [isDesktop]="isDesktop"
      [products]="bestSellingProducts$ | async">
    </app-best-selling-products-list>

    <app-last-deals-products-list
      [isMobile]="isMobile"
      [isDesktop]="isDesktop"
      [products]="lastDealsProducts$ | async">
    </app-last-deals-products-list>

    <app-custom-seo-content
      *ngIf="customSeoContent$ | async"
      [seoContent]="customSeoContent$ | async"
      [source]="hubPageSource"
    ></app-custom-seo-content>

  </app-page-content-wrapper>
</div>
